//General api settings here..
const url = "https://api.africaplusworld.com";

const api = "https://api.africaplusworld.com/v1/";

const adminApi = 'admin';

export default url;

export { api, adminApi };